import { render, staticRenderFns } from "./FormDatepickerPlaceholder.vue?vue&type=template&id=40454dba&"
import script from "./FormDatepickerPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FormDatepickerPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports